<template>
	<div class="news">
		<div class="innerhdon">
			<mbHd />
		</div>
		<div class="innerCon">
			<div class="wrapper">
				<currentLocation></currentLocation>
				<div class="member clearfix">
					<memberFl></memberFl>
					<div class="memberFr">
						<div class="mbTit">
							<h3><img class="mbTiticon" :src="mbTiticon" />会员充值</h3>
						</div>
						<div class="topUps">
							<div class="comPading">
								<div class="flexbox">
									<span class="lable">账户余额：</span>
									<div class="money"><strong>50.00</strong>元</div>
								</div>
								<div class="flexbox">
									<span class="lable">充值：</span>
									<div class="choseLst">
										<ul>
											<li :class="{on:current==index}" 
												@click="tabItem(index)" 
												v-for="(item,index) in choseLst" 
												:key="item.index">
												{{item}}
											</li>
										</ul>
									</div>
								</div>
								<div class="flexbox">
									<span class="lable">支付方式：</span>
									<div class="way">
										<ul>
											<li>
												<img src="../assets/img/wxzf.png" />
											</li>
											<li>
												<img src="../assets/img/zfb.png" />
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div class="combtnMod">
								<button class="btn okBtn">确定</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<foot />
		<rightFix />
	</div>
</template>
<script>
	import mbHd from '@/components/mbHd.vue'
	import foot from '@/components/foot.vue'
	import rightFix from '@/components/rightFix.vue'
	import currentLocation from '@/components/currentLocation.vue'
	import memberFl from '@/components/memberFl.vue'
	export default {
		name: 'News',
		components: {
			foot,
			rightFix,
			mbHd,
			currentLocation,
			memberFl
		},
		data() {
			return {
				mbTiticon: require('@/assets/img/icon.png'),
				current: 0,
				choseLst:['月卡/30次','半年卡/180次','年卡/360次']
			}
		},

		methods: {
			tabItem (index) {
	      this.current = index
	    },
		}
	}
</script>
<style scoped lang="scss">
	
</style>